import {Data} from "./Data";

require('../index.html');
import {paData} from './framework/paData';
import {paTpl} from "./framework/paTpl";
import {paRoute} from "./framework/paRoute";
import {paIframeChild} from "./framework/paIframeChild";
import {get} from "./framework/paDom";
import {Events} from "./Events";
import {Main} from "./Main";
import {paTab} from "./framework/components/paTab";

export const paApp = {
    init() {
        this.initAfterDom();

        Promise.all([
            paData.loaded()
            // paChart.loaded()
        ]).then(this.initAfterLoad);

    },
    /**
     * that will be fired before DOM loads
     */
    initCritical() {
        // your code here
        // no jquery
    },
    /**
     * that will be fired after DOM loads
     */
    initAfterDom() {
        paTab.init();
        if (!paIframeChild.isIframe) {
            paTpl.renderEmbedCode();
        }
    },
    /**
     * that will be fired after DOM and data loads
     */
    initAfterLoad() {
        Data.init();
        paApp.renderDecades();
        paApp.imgMap();
        Main.init();
        Events.init();
        paIframeChild.allIsDone();
        // your code here
    },
    imgMap() {
        let imagesToPreload = [];
        Object.keys(Data.categoryMap).forEach(function (key) {
            imagesToPreload.push(paRoute.imageUrl('names/' + key + '.png'));
            imagesToPreload.push(paRoute.imageUrl('charts/' + key + '.png'));
        });
        for (let i = 1; i <= Object.keys(Data.tree).length; i++) {
            imagesToPreload.push(paRoute.imageUrl('decades/' + i + '.jpg'));
        }
        imagesToPreload.push(paRoute.imageUrl('decades/bg2.png'));
        paTpl.preloadImages(imagesToPreload);
    },
    renderDecades() {
        for (let index in Data.tree) {
            let tpl = paTpl.get('#decade-list-el-template', {
                title: Data.tree[index].name,
                id: index
            });
            get('#pa-decades-list').appendChild(tpl);
            for (let indexLi in Data.tree[index].data) {
                let tplChild = paTpl.get('#category-li-template', {
                    category: Data.tree[index].data[indexLi].category,
                    id: Data.tree[index].data[indexLi].id,
                    gender: Data.tree[index].data[indexLi].gender,
                });
                get('#decade-submenu-' + index).appendChild(tplChild);
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/js/paApp.js